<template>
    <div style="height:90vh;">
        <el-tabs v-model="activeName" type="border-card" @tab-click="pageNews(activeName)">
            <el-tab-pane :label="item.name" :name="item.value + ''" v-for="(item, index) in newsList" :key="index">
                <news-table :list="news" :hideHeader="false"
                    v-if="activeName == '1' || activeName == '2' || activeName == '3'" />
                <law-table :list="law" :hideHeader="false" v-if="activeName == '4'" />
                <download-table :list="download" :hideHeader="false" v-if="activeName == '5'" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import home from "@/api/home/index"
import newsTable from "../components/newsTable";
import lawTable from "../components/lawTable";
import downloadTable from "../components/downloadTable";

export default {
    components: {
        newsTable,
        lawTable,
        downloadTable
    },
    data() {
        return {
            newsList: [{
                name: '行业资讯',
                value: 1
            }, {
                name: '平台资讯',
                value: 2
            }, {
                name: '企业资讯',
                value: 3
            }, {
                name: '政策法规',
                value: 4
            }, 
            // {
            //     name: '相关下载',
            //     value: 5
            // }
        ],
            activeName: '1',
            news: [],
            law: [],
            download: [],
            typeNumber: null
        };
    },

    mounted() {

    },
    created() {
        if (this.$route.query.type) {
            this.typeNumber = this.$route.query.type
            if (this.typeNumber == '3') {
                this.activeName = '4'
            }
            if (this.typeNumber == '4') {
                this.activeName = '5'
            }
        }
        this.pageNews(1);
        this.pageRelatedDownload();
        this.pageLaw()
    },

    methods: {
        // 切换tab
        pageNews(type) {
            let t = type - 0
            if (type == '1' || type == '2' || type == '3') {
                home.pageNews({
                    type: t ? t : '',
                    page: 1,
                    limit: 9
                }).then(res => {
                    if (res.code == 0) {
                        this.news = res.data.list;
                    }
                })
            } else if (type == '4') {
                this.pageLaw()
            } else if (type == '5') {
                this.pageRelatedDownload()
            }
        },

        // 政策列表（最新）
        pageLaw() {

            home.pageLaw({
                page: 1,
                limit: 9
            }).then(res => {
                if (res.code == 0) {
                    this.law = res.data.list;
                }
            })
        },


        // 下载列表（最新）
        pageRelatedDownload() {

            home.pageRelatedDownload({
                page: 1,
                limit: 9
            }).then(res => {
                if (res.code == 0) {
                    this.download = res.data.list;
                }
            })
        },

    },
};
</script>

<style lang="scss" scoped></style>